import { type Padding } from '@xyflow/system';

import { FIT_VIEW_BUFFER, FIT_VIEW_LEFT_RIGHT_PADDING_PX } from '../utils/getFitViewPadding';

/** Wide enough for side-by-side original / translation rows on the review step. */
export const LOCALIZATION_CARD_WIDTH_PX = 480;

/** Gap between the card and the right edge of the canvas pane. */
export const LOCALIZATION_CARD_RIGHT_PX = 24;

/** Breathing room between the framed source image and the card's left edge. */
const CARD_GAP_PX = 16;

/**
 * Cap on the share of the pane the card is allowed to claim. The card keeps its width on a narrow
 * viewport, where reserving all of it would leave almost nothing to frame the image into.
 */
const MAX_CARD_RESERVE_RATIO = 0.5;

/**
 * fitView padding that frames the source image to the *left* of the tool card instead of the middle
 * of the pane. The card is docked bottom-right and runs nearly the full height, so a centered image
 * ends up underneath it once the pane gets narrow.
 *
 * Asymmetric padding shifts rather than just shrinks: xyflow centers the bounds first, then offsets
 * toward any side whose resulting gap came out smaller than the padding asked for.
 */
export const getLocalizationFitViewPadding = (paneWidth: number): Padding => {
  const cardReservePx = LOCALIZATION_CARD_RIGHT_PX + LOCALIZATION_CARD_WIDTH_PX + CARD_GAP_PX;
  const rightPx = paneWidth > 0 ? Math.min(cardReservePx, paneWidth * MAX_CARD_RESERVE_RATIO) : cardReservePx;

  return {
    bottom: FIT_VIEW_BUFFER,
    left: `${FIT_VIEW_LEFT_RIGHT_PADDING_PX}px`,
    right: `${Math.round(rightPx)}px`,
    top: FIT_VIEW_BUFFER,
  };
};
